














    import { Component, Vue, Prop, Watch } from "vue-property-decorator";
    import {nextTick} from "process";
import { throws } from "assert";

    @Component({

    })
    export default class MiltiLineEdit extends Vue {
        @Prop({}) icon : string;
        @Prop({}) defaultValue : string;
        @Prop({}) placeholder : string;
        @Prop({}) placeholderNoMove : boolean;
        @Prop({}) borderHide : boolean;
        @Prop({}) error : boolean;
        errorInternal: boolean = false;
        @Prop({}) password : {
            default: false,
            type: boolean
        };
        @Prop({}) paddingBottom : {
            default: false,
            type: boolean
        };
        @Prop({}) readonly : {
            default: false,
            type: boolean
        };

        ready:boolean = false;

        value:string = '';
        isPlaceholderVisible: boolean = true;
        focusing: boolean = false;
        input:HTMLInputElement = null;

        mounted(){
            this.input = this.$refs.textInput as HTMLInputElement;
            this.establishEvents();
            this.updateDefaultValue();
            this.establishEvents();
            this.ready = true;
        }

        @Watch("value")
        updatePlaceholder() {
            this.isPlaceholderVisible = this.value === ''
            this.errorInternal = false;
        }

        @Watch("error")
        updateErr(err) {
            this.errorInternal = err;
        }

        clear(){
            this.updatevalue('');
            this.setValue('');
        }

        setValue(to:string){
            this.value = to;
            // DON'T SET INNERHTML!!! SERIOUS XSS VULNERABILITY
            (this.$refs.textInput as HTMLInputElement).innerText = to;
            this.$forceUpdate();
        }

        establishEvents(){
            let input = (this.$refs.textInput as HTMLDivElement);

            input.addEventListener('keydown', (e) => {
                nextTick(() => {
                    this.updatevalue(input.textContent)
                })
            })
            input.addEventListener('keyup', (e) => {
                nextTick(() => {
                    this.updatevalue(input.textContent)
                })
            })
        }

        focus(){
            this.controlCaretVisibility()
            if(!this.readonly){
                this.input.focus();
                this.focusing = true;
            }
        }

        unfocus(){
            if(!this.value || (this.value).trim() == ''){
                this.value = '';
                this.focusing = false;
            }
        }

        controlCaretVisibility(){
            let input = (this.$refs.textInput as HTMLElement)
            if(input.textContent && input.textContent.length > 0){
                input.style.display = "block";
            }
        }

        updateHeight(newHeight:number){
            (this.$refs.textWrapper as HTMLElement).style.height = newHeight + "px";

            if(newHeight > 50){
                (this.$refs.textWrapper as HTMLElement).style.top = "auto";
                (this.$refs.textWrapper as HTMLElement).style.paddingBottom = "10px"
            }else{
                (this.$refs.textWrapper as HTMLElement).style.top = "0px"
            }

            (this.$refs.textInput as HTMLElement).style.overflow = "auto";
        }

        @Watch('$refs.textInput.value')
        updatevalue(to){
            if(this.ready){
                this.value = (this.$refs.textInput as any).innerText;
                this.errorInternal = false;
                this.$emit('input', this.value);

                this.controlCaretVisibility()

                let height = (this.$refs.textInput as Element).scrollHeight;
                this.updateHeight(height);
            }
        }

        @Watch('defaultValue')
        updateDefaultValue(){
            if(!this.focusing){
                this.value = this.defaultValue || '';
                this.setValue(this.value);

                if(this.value && (this.value).trim() !== ''){
                    this.focusing = true;
                }
            }
        }

    }

